import { createI18n } from 'vue-i18n'
import en from '~/assets/translations/en.json'
import { Locales } from '~/enums'

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: Locales.en,
    messages: {
      en,
    },
  })
  vueApp.use(i18n)
})
